export type StrategyOption = {
  key: string;
  type: string;
  name: string;
  always_enabled: boolean;
  deprecated?: boolean;
  tcost_file_version?: string;
};

export const getId = (strategy: StrategyOption): string => {
  return `${strategy.key}::${strategy.tcost_file_version || 'deprecated'}`;
};

export default [
  { key: 'None', type: 'None', name: 'None', always_enabled: true, tcost_file_version: undefined },
  { key: 'Fixed', type: 'Fixed', name: 'Fixed Costs Only', always_enabled: true, tcost_file_version: undefined },
  {
    key: 'VWAP1',
    type: 'VWAP1',
    name: 'VWAP 1-Day Volume',
    always_enabled: false,
    deprecated: true,
    tcost_file_version: undefined,
  },
  {
    key: 'VWAP3',
    type: 'VWAP3',
    name: 'VWAP 3-Day Volume',
    always_enabled: false,
    deprecated: true,
    tcost_file_version: undefined,
  },
  {
    key: 'Optimal0.3',
    type: 'Optimal',
    name: 'IS Neutral',
    always_enabled: false,
    deprecated: true,
    tcost_file_version: undefined,
  },

  { key: 'VWAP1', type: 'VWAP1', name: 'VWAP 1-Day Volume', always_enabled: false, tcost_file_version: '1.0' },
  { key: 'VWAP3', type: 'VWAP3', name: 'VWAP 3-Day Volume', always_enabled: false, tcost_file_version: '1.0' },
  { key: 'OPT_MODERATE', type: 'Optimal', name: 'IS Neutral', always_enabled: false, tcost_file_version: '1.0' },
] as StrategyOption[];
